function errorSummary(data, variazioni={}) {

    const variazione = k => Object.keys(variazioni).includes(k) ? variazioni[k] : k;

    let errs = {};
    data.forEach(v => {
        errs[variazione(v.field)] = v.message;
    });
    return errs;

}

export default errorSummary;